import { LIST_ALL_VIDEO_ACADEMY, SUBMIT_TEST } from "../actions/academy";
import { ERRORS_SHOW } from "../actions/errors";
import Api from "../../service/api-web";

const state = {
  list: []
};

const getters = {
  getVideosAcademy: state => state.list
};
const actions = {
  [LIST_ALL_VIDEO_ACADEMY]: ({ dispatch, commit }) => {
    return new Promise((resolve, reject) => {
      Api.v4.academy
        .getAllVideosAcademy()
        .then(resp => {
          const response = resp.data;
          commit(LIST_ALL_VIDEO_ACADEMY, response);
          resolve(response);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },

  [SUBMIT_TEST]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.academy
        .submitTest(payload.sectionid, payload.respostas)
        .then(resp => {
          const response = resp.data;
          resolve(response);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  }
};
const mutations = {
  [LIST_ALL_VIDEO_ACADEMY](state, value) {
    state.list = value;
  }
};
export default {
  state,
  getters,
  actions,
  mutations
};
